import { setOrganizationId, useGetCurrentUserQuery } from '@carboncopyco/data';
import type {
  IActiveOrganization,
  UserPersonas,
} from '@carboncopyco/types/desktop';
import { createContext, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

type UserContextType = {
  activeOrganization: IActiveOrganization;
  setActiveOrganization: (newActiveOrganization: any) => void;
  personas: UserPersonas | null;
  setPersonas: (newPersonasData: UserPersonas | null) => void;
  isLoadingApp: boolean;
  setIsLoadingApp: (isLoadingApp: boolean) => void;
  me: any;
  setMe: (newActiveUser: any) => void;
  isAuthenticated: boolean;
  defaultOrganization: number | undefined;
};

export const UserContext = createContext<UserContextType>({
  activeOrganization: {} as IActiveOrganization,
  setActiveOrganization: () => {},
  personas: {} as UserPersonas | null,
  setPersonas: () => {},
  isLoadingApp: false,
  setIsLoadingApp: () => {},
  me: {},
  setMe: () => {},
  isAuthenticated: false,
  defaultOrganization: undefined,
});

export const useUser = () => {
  return useContext(UserContext);
};

export const UserContextProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [isLoadingApp, setIsLoadingApp] = useState(false);
  const [me, setMe] = useState<any>(null);
  const [personas, setPersonas] = useState<UserPersonas | null>(null);
  const [activeOrganization, setActiveOrganization] = useState<any>();
  const dispatch = useDispatch();
  const { data: user } = useGetCurrentUserQuery();
  const defaultOrganization = user?.user?.defaultOrganization;

  const handleSetActiveOrganization = (newActiveOrganization: any) => {
    if (!newActiveOrganization) return;
    setActiveOrganization(newActiveOrganization);
    dispatch(setOrganizationId(newActiveOrganization?.id?.toString()));
  };

  return (
    <UserContext.Provider
      value={{
        activeOrganization,
        setActiveOrganization: handleSetActiveOrganization,
        isLoadingApp,
        setIsLoadingApp,
        me,
        setMe,
        personas,
        setPersonas,
        isAuthenticated: !!me?.email,
        defaultOrganization,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
